'use client'

import { useState } from 'react'
import { useRouter } from 'next/navigation'
import { t } from '../lib/i18n'

export default function GeolocationButton({ defaultCity = 'valencia', locale = 'es' }) {
  const [isLoading, setIsLoading] = useState(false)
  const [geoError, setGeoError] = useState('')
  const router = useRouter()
  const T = t(locale)

  const handleGeolocation = () => {
    console.log('[geo] Click: iniciando geolocalización')
    setIsLoading(true)
    setGeoError('')

    if (!navigator.geolocation) {
      console.warn('[geo] Error: geolocation no soportado')
      setGeoError(T.geoUnsupported)
      setIsLoading(false)
      return
    }

    console.log('[geo] Request: solicitando posición (timeout 10s)')
    navigator.geolocation.getCurrentPosition(
      (position) => {
        try {
          const { latitude, longitude } = position.coords
          console.log(`[geo] Success: lat=${latitude.toFixed(4)}, lng=${longitude.toFixed(4)}`)
          // Redirect to default city with coords as query params
          // Future: could use coords to determine closest city
          router.push(`/parques-caninos/${defaultCity}?lat=${latitude}&lng=${longitude}`)
        } catch (err) {
          console.error('[geo] Error procesando coordenadas:', err)
          setGeoError('No pudimos acceder a tu ubicación. Puedes permitir ubicación en el navegador o elegir ciudad.')
        } finally {
          setIsLoading(false)
        }
      },
      (err) => {
        // Error codes: 1=PERMISSION_DENIED, 2=POSITION_UNAVAILABLE, 3=TIMEOUT
        console.warn(`[geo] Error: code=${err.code}, message=${err.message}`)
        
        let errorMsg = 'No pudimos acceder a tu ubicación.'
        if (err.code === 1) {
          errorMsg = 'No pudimos acceder a tu ubicación. Puedes permitir ubicación en el navegador o elegir ciudad.'
        } else if (err.code === 2) {
          errorMsg = 'Ubicación no disponible. Elige una ciudad manualmente.'
        } else if (err.code === 3) {
          errorMsg = 'La ubicación tardó demasiado. Elige una ciudad manualmente.'
        }
        
        setGeoError(errorMsg)
        setIsLoading(false)
      },
      {
        enableHighAccuracy: false,
        timeout: 10000,
        maximumAge: 60000
      }
    )
  }

  return (
    <div style={{ display: 'contents' }}>
      <button
        onClick={handleGeolocation}
        disabled={isLoading}
        className="btn-cta"
      >
        {isLoading ? 'Localizando...' : 'Ver parques cerca de mí'}
      </button>
      
      {geoError && (
        <div
          className="note"
          role="status"
        >
          {geoError}{' '}
          <a
            href="#cities"
            onClick={() => setGeoError('')}
            style={{
              color: 'var(--c-primary)',
              textDecoration: 'none',
              fontWeight: '600'
            }}
          >
            Ver ciudades
          </a>
        </div>
      )}
    </div>
  )
}
